import { render, staticRenderFns } from "./FosterCaliforniaLayout.vue?vue&type=template&id=4c9a653d&scoped=true&"
import script from "./FosterCaliforniaLayout.vue?vue&type=script&lang=js&"
export * from "./FosterCaliforniaLayout.vue?vue&type=script&lang=js&"
import style0 from "./FosterCaliforniaLayout.vue?vue&type=style&index=0&id=4c9a653d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a653d",
  null
  
)

export default component.exports